import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = ({ data }) => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState({ success: false, error: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_eftqygo',        // Replace with your EmailJS service ID
      'template_6fhzxa7',       // Replace with your EmailJS template ID
      formData,
      'D0DWH9h1RrmRHxssB'         // Replace with your EmailJS public key
    )
      .then(() => {
        setStatus({ success: true, error: false });
        setFormData({ name: '', subject: '', email: '', message: '' });
      })
      .catch(() => {
        setStatus({ success: false, error: true });
      });
  };

  return (
    <section id="contact">
      <div className="row section-head">
        <div className="twelve columns header-col">
          <h1><span>Get In Touch.</span></h1>
        </div>
        <div className="ten columns">
          <p className="lead">{data?.message}</p>
        </div>
      </div>

      <div className="row">
        <div className="twelve columns">
          <form className="contact-form" onSubmit={handleSubmit}>
            <label>Name<span className="required">*</span></label>
            <input
              type="text"
              name="name"
              value={formData.name}
              required
              onChange={handleChange}
            />

            <label>Email<span className="required">*</span></label>
            <input
              type="email"
              name="email"
              value={formData.email}
              required
              onChange={handleChange}
            />

            <label>Subject</label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            />

            <label>Message<span className="required">*</span></label>
            <textarea
              name="message"
              value={formData.message}
              required
              onChange={handleChange}
            />

            <div id="success"></div>
            <button className="submit" type="submit">Submit</button>
          </form>

          {status.error && (
            <div id="message-warning">Error, please try again later.</div>
          )}

          {status.success && (
            <div id="message-success">
              <i className="fa fa-check"></i>Your message was sent, thank you!<br />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
